import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Link } from "react-router-dom";
import './App.css';
import About from "./About";
import Main from "./Main";
import BlogList from "./components/blog/BlogList"; 
import BlogPost from "./components/blog/BlogPost";  

function App() {
  const [theme, setTheme] = useState(() => {
    // Check localStorage for saved theme preference
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'dark';
  });

  useEffect(() => {
    // Apply theme to document
    document.documentElement.setAttribute('data-theme', theme);
    // Save theme preference
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'dark' ? 'light' : 'dark');
  };

  return (
    <div className="App">
      <nav className="terminal-nav">
        <Link to="/" className="nav-title">
          <span className="nav-bracket">[</span>C12<span className="nav-bracket">]</span>
          </Link> 
        <div className="nav-links">
          <Link to="/about" className="nav-link">/about</Link>
          <Link to="/blog" className="nav-link">/blog</Link>
        </div>
      </nav>
      <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
        {theme === 'dark' ? '☀️' : '🌙'} {theme === 'dark' ? 'Light' : 'Dark'}
      </button>
       <div className="me-auto">
        <Routes>
          <Route exact path="/" element={<Main />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<BlogList />} />       
          <Route path="/blog/:postId" element={<BlogPost />} /> 
        </Routes>
      </div>
    </div>
  );
}

export default App;
